/** @format */

import {
    CARTON_SUBSTRATES,
    CARTON_UNLAMINATED_WHITE_PAPER,
    CARTON_BRIGHT_WHITE_PAPER
} from 'frontier-constants';
import {GridSelect, IconButton, Popover} from '@sttark/design-system';
import {createAndClickOpen} from 'frontier/utilities/download';
import React from 'react';

export default function CartonMaterialSelect({order, onChange}) {
    return (
        <GridSelect
            minCols={3}
            maxCols={3}
            ratio="1x1"
            options={CARTON_SUBSTRATES.map(s => {
                // Remap the value for white paper since we are actually changing
                // Material based on lam/unlam choices
                const option = {...s};

                option.info = () => (
                    <>
                        <Popover
                            content={
                                <p>
                                    {s.info}
                                    {s.url && (
                                        <>
                                            {' '}
                                            <a
                                                href={s.url}
                                                target="_blank"
                                                style={{
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                See more...
                                            </a>
                                        </>
                                    )}
                                </p>
                            }>
                            <IconButton secondary icon="info" small />
                        </Popover>
                        <IconButton
                            secondary
                            icon="zoomin"
                            small
                            onClick={() => createAndClickOpen(s.hoverImage)}
                        />
                    </>
                );
                return option;
            })}
            value={order.substrate_id}
            onChange={onChange}
        />
    );
}
